/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'facebook': {
    width: 16,
    height: 16,
    viewBox: '0 0 9 18',
    data: '<path pid="0" d="M5.842 18V9.789h2.656l.395-3.2H5.842V4.545c0-.925.247-1.557 1.525-1.557H9V.124a20.4 20.4 0 0 0-2.375-.125c-2.356 0-3.962 1.495-3.962 4.234V6.6H0v3.2h2.663V18z" fill-rule="evenodd"/>'
  }
})
